/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Label_WarehouseInputs */

const vi_product_lot_detail_label_warehouse = /** @type {(inputs: Product_Lot_Detail_Label_WarehouseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho`)
};

/**

* @param {Product_Lot_Detail_Label_WarehouseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_label_warehouse = /** @type {((inputs?: Product_Lot_Detail_Label_WarehouseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Label_WarehouseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_label_warehouse(inputs)
});